import { noop } from "lodash";
import { useFormContext } from "react-hook-form";

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  useFormField,
} from "@/components/ui/form";
import {
  NumberInput as NumberTextInput,
  type NumberTextInputProps,
} from "@/components/ui/number-input";
import { cn } from "@/lib/utils";

type Props = NumberTextInputProps & {
  name: string;
  label?: string;
  autoFocus?: boolean;
  description?: string;
  selectTextOnFocus?: boolean;
  suffix?: string;
  prefix?: string;
};

export const FormNumberInput = ({
  label,
  name,
  description,
  placeholder,
  onFocus = noop,
  selectTextOnFocus = true,
  onKeyDown = noop,
  suffix,
  prefix,
  ...rest
}: Props) => {
  const form = useFormContext();
  const { error } = useFormField();

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => {
        const handleBlur = (event: any) => {
          field.onChange(event);
          field.onBlur();
          rest.onBlur?.(event);
        };

        return (
          <FormItem>
            {label && <FormLabel>{label}</FormLabel>}
            <FormControl>
              <NumberTextInput
                selectTextOnFocus={true}
                placeholder={placeholder}
                onFocus={() => onFocus(field.value)}
                onKeyDown={onKeyDown}
                {...field}
                {...rest}
                onBlur={handleBlur}
                onChange={noop}
                suffix={suffix}
                prefix={prefix}
                aria-invalid={error ? true : undefined}
                className={cn(
                  rest.className,
                  error && "!border-destructive !ring-destructive",
                )}
              />
            </FormControl>
            {description && <FormDescription>{description}</FormDescription>}
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};
